import { isNull } from 'lodash';
import React, { useCallback, useEffect, useRef } from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { useFirebaseAuth } from '../../../hooks';
import { media } from '../../../services/media';
import { themeStyles } from '../../../services/themeStyles';
import { VisibleOn } from '../../VisibleOn';
import { Background } from './Background';
import { NavigationList } from './NavigationList';

export const HeaderMenu: React.FC<any> = ({
    mobile = false,
    onCloseClick,
    items,
}) => {
    const { currentUser } = useFirebaseAuth();
    const componentWrapperRef = useRef(null);

    const handleOutsideClick = useCallback(() => {
        if (!isNull(componentWrapperRef.current)) {
            onCloseClick();
        }
    }, [onCloseClick]);

    useEffect(() => {
        if (mobile) {
            document.addEventListener('click', handleOutsideClick);
        }

        return () => {
            if (mobile) {
                document.removeEventListener('click', handleOutsideClick);
            }
        };
    });

    if (currentUser === undefined || !items.length) {
        return null;
    }

    return (
        <>
            <Menu ref={componentWrapperRef}>
                <VisibleOn mobile tablet>
                    <Background />
                </VisibleOn>
                <NavigationList items={items} />
            </Menu>
        </>
    );
};

const HeaderMenuAnimation = css`
    @keyframes HeaderMenuAnimationMain {
        0% {
            transform: translate3d(100%, 0, 0);
        }
        100% {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes HeaderMenuAnimationList {
        0% {
            opacity: 0;
        }
        40% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    ${media.max('lg')} {
        animation: HeaderMenuAnimationMain 400ms ease;
    }

    ${media.min('lg')} {
        animation: none;
    }
`;

const Upscore = themeStyles(
    'upscore',
    css`
        transform-origin: 100% 0;

        ${media.min('md')} {
            font-size: 24px;
        }

        ${media.max('lg')} {
            position: absolute;
            z-index: 1;
            top: 0;
            right: 0;
            padding: 60px 35px 15px 15px;
        }

        ${media.min('lg')} {
            font-size: 18px;
            padding: 20px 0;
        }

        ${media.min('xl')} {
            font-size: 24px;
        }

        ${HeaderMenuAnimation}
    `,
);

const Menu = styled.div`
    display: flex;
    flex-flow: column wrap;
    align-items: flex-end;

    font-size: 20px;
    line-height: 1.6em;
    text-align: right;

    width: 100%;

    ${Upscore}
`;
